var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isMobile)?_c('div',[_c('img',{staticClass:"background",attrs:{"src":"/background.png","alt":"background"}}),_c('router-view'),(_vm.showDisclosure)?_c('disclosure',{on:{"close":_vm.hideDisclosure}}):_vm._e()],1):_c('mobile-landing')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }